import React from 'react';
import propTypes2 from 'prop-types';

import { camelize } from '../utils/String';
import { encodeSvg } from '../../../utils/react';

const evtNames = ['click', 'dblclick', 'dragend', 'mousedown', 'mouseout', 'mouseover', 'mouseup', 'recenter'];

const wrappedPromise = function () {
  var wrappedPromise = {},
    promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
  wrappedPromise.then = promise.then.bind(promise);
  wrappedPromise.catch = promise.catch.bind(promise);
  wrappedPromise.promise = promise;

  return wrappedPromise;
};

const getIconMarker = (markerColor, productType) => {
  if (productType && ['SCR', 'BOA', 'TMS'].includes(productType)) {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='36' height='36'>
        <path fill='none' d='M0 0h36v36H0z'></path>
        <path fill='#fff' d='M2 6h32v24H2z'></path>
        <path
          fill={markerColor}
          d='M34 30H2V6h32zM4 28h28V8H4zm3-18h4v4H7zm0 6h4v4H7zm0 6h4v4H7zm12-12h4v4h-4zm0 6h4v4h-4zm0 6h4v4h-4zm-6-12h4v4h-4zm0 6h4v4h-4zm0 6h4v4h-4zm12-12h4v4h-4zm0 6h4v4h-4zm0 6h4v4h-4z'
        ></path>
      </svg>
    );
  } else if (productType && ['HC', 'HCD', 'RP', 'RPM'].includes(productType)) {
    return (
      <svg width={36} height={36} viewBox='0 0 36 36' xmlns='http://www.w3.org/2000/svg'>
        <path fill='none' d='M0 0H36V36H0z' />
        <path
          d='M9.727 3A4.727 4.727 0 005 7.727v22.459a2.364 2.364 0 004.727 0v-.441a78.7 78.7 0 0016.545 0v.441a2.364 2.364 0 004.727 0V7.729a4.727 4.727 0 00-4.727-4.727z'
          fill='#fff'
        />
        <path
          d='M9.727 3A4.727 4.727 0 005 7.727v22.459a2.364 2.364 0 104.727 0v-.441a78.7 78.7 0 0016.545 0v.441a2.364 2.364 0 104.727 0V7.729a4.727 4.727 0 00-4.727-4.727zm3.545 2.36h9.455a1.182 1.182 0 01.14 2.36 1.054 1.054 0 01-.14 0h-9.455a1.182 1.182 0 01-.14-2.36c.047-.003.095-.003.141 0zm-5.913 4.731h21.277v6.417a1.174 1.174 0 01-.964 1.162 57.456 57.456 0 01-9.669.692 57.242 57.242 0 01-9.669-.695 1.171 1.171 0 01-.967-1.161zm2.36 11.818a2.36 2.36 0 11-2.36 2.36 2.36 2.36 0 012.36-2.36zm16.545 0a2.36 2.36 0 11-2.36 2.36 2.36 2.36 0 012.36-2.36z'
          fill={markerColor}
        />
      </svg>
    );
  } else {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='37' height='52'>
        <path
          fill='#ffffff'
          d='M3.487787961959839,18.429518461227417 C3.487787961959839,10.41846873747051 10.20049514428028,3.929518461227417 18.48778796195984,3.929518461227417 C26.775080779639396,3.929518461227417 33.48778796195984,10.41846873747051 33.48778796195984,18.429518461227417 C33.48778796195984,26.440568184984322 26.775080779639396,32.92951846122742 18.48778796195984,32.92951846122742 C10.20049514428028,32.92951846122742 3.487787961959839,26.440568184984322 3.487787961959839,18.429518461227417 z'
        />
        <path
          d='M18.5 0C8.325 0 0 8.25882 0 18.3529C0 31.5059 18.5 52 18.5 52C18.5 52 37 31.5059 37 18.3529C37 8.25882 28.675 0 18.5 0ZM18.5 31.6588C11.2542 31.6588 5.55 25.8471 5.55 18.8118C5.55 11.6235 11.4083 5.96471 18.5 5.96471C25.7458 5.96471 31.45 11.7765 31.45 18.8118C31.45 25.8471 25.7458 31.6588 18.5 31.6588Z M18.5004 25.2355C22.0764 25.2355 24.9754 22.3596 24.9754 18.812C24.9754 15.2643 22.0764 12.3884 18.5004 12.3884C14.9243 12.3884 12.0254 15.2643 12.0254 18.812C12.0254 22.3596 14.9243 25.2355 18.5004 25.2355Z'
          fill={markerColor}
        />
      </svg>
    );
  }
};

const getIconByContext = (context, selected) => {
  const innerIconPlace = (
    <foreignObject x='11' y='16' width='21' height='21'>
      <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M17.5 8.90909C17.5 14.4773 10.5 19.25 10.5 19.25C10.5 19.25 3.5 14.4773 3.5 8.90909C3.5 7.01038 4.2375 5.18944 5.55025 3.84685C6.86301 2.50426 8.64348 1.75 10.5 1.75C12.3565 1.75 14.137 2.50426 15.4497 3.84685C16.7625 5.18944 17.5 7.01038 17.5 8.90909Z'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M10.375 11.125C11.7557 11.125 12.875 10.0057 12.875 8.625C12.875 7.24429 11.7557 6.125 10.375 6.125C8.99429 6.125 7.875 7.24429 7.875 8.625C7.875 10.0057 8.99429 11.125 10.375 11.125Z'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </foreignObject>
  );
  const innerIconTraffic = (
    <foreignObject x='12' y='17' width='21' height='21'>
      <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle
          cx='5.5'
          cy='15.5'
          r='2.5'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M2.9 15.0732L1 15.0732V2.55469H20V15.0732L19.05 15.0732'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M8 15H14'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M1 6H6V8.99233H1'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M14 15V6H10V15'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <rect
          x='16.9883'
          y='6'
          width='3'
          height='2.98942'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <circle
          cx='16.5'
          cy='15.5'
          r='2.5'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </foreignObject>
  );
  const innerIconAddress = (
    <foreignObject x='11' y='16' width='21' height='21'>
      <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M2.625 9.17881C2.625 8.52618 2.94342 7.9146 3.47808 7.54035L10.5 2.625L17.5219 7.54035C18.0566 7.9146 18.375 8.52618 18.375 9.17881V16.8C18.375 17.2177 18.1906 17.6183 17.8624 17.9137C17.5342 18.2091 17.0891 18.375 16.625 18.375H4.375C3.91087 18.375 3.46575 18.2091 3.13756 17.9137C2.80937 17.6183 2.625 17.2177 2.625 16.8V9.17881Z'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M7.875 18.375V10.5H13.125V18.375'
          stroke={selected ? 'white' : '#212529'}
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </svg>
    </foreignObject>
  );
  const innerIconPostalCode = (
    <foreignObject x='11' y='17' width='21' height='21'>
      <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <line x1='5.375' y1='3.625' x2='5.375' y2='17.375' stroke='white' stroke-width='2' stroke-linecap='round' />
        <line x1='8.875' y1='3.625' x2='8.875' y2='17.375' stroke='white' stroke-width='2' stroke-linecap='round' />
        <line x1='12.375' y1='3.625' x2='12.375' y2='17.375' stroke='white' stroke-width='2' stroke-linecap='round' />
        <line x1='15.875' y1='3.625' x2='15.875' y2='17.375' stroke='white' stroke-width='2' stroke-linecap='round' />
      </svg>
    </foreignObject>
  );
  const innerIconCanton = (
    <foreignObject x='11' y='17' width='21' height='21'>
      <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M16.375 2.625H4.625C3.52043 2.625 2.625 3.52043 2.625 4.625V16.375C2.625 17.4796 3.52043 18.375 4.625 18.375H16.375C17.4796 18.375 18.375 17.4796 18.375 16.375V4.625C18.375 3.52043 17.4796 2.625 16.375 2.625Z'
          stroke='white'
          stroke-width='2'
          stroke-miterlimit='10'
        />
        <path d='M6.125 2.625L18.375 14.875' stroke='white' stroke-width='2' stroke-miterlimit='10' />
        <path d='M2.625 6.125L14.875 18.375' stroke='white' stroke-width='2' stroke-miterlimit='10' />
        <path d='M11.375 7.875L2.625 16.625' stroke='white' stroke-width='2' stroke-miterlimit='10' />
        <path d='M18.375 7L7 18.375' stroke='white' stroke-width='2' stroke-miterlimit='10' />
      </svg>
    </foreignObject>
  );
  const innerIconId = (
    <foreignObject x='12' y='17' width='21' height='21'>
      <svg width='21' height='21' viewBox='0 0 21 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M17.8972 12.0011L12.0069 17.893C11.8543 18.0458 11.673 18.167 11.4736 18.2497C11.2741 18.3324 11.0603 18.375 10.8444 18.375C10.6285 18.375 10.4147 18.3324 10.2152 18.2497C10.0157 18.167 9.83452 18.0458 9.68193 17.893L2.625 10.8424V2.625H10.8403L17.8972 9.68377C18.2032 9.9917 18.375 10.4082 18.375 10.8424C18.375 11.2766 18.2032 11.6932 17.8972 12.0011V12.0011Z'
          stroke='#212529'
          stroke-width='2'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <circle cx='6.125' cy='6.125' r='0.875' fill='#212529' />
      </svg>
    </foreignObject>
  );
  const innerIconDefault = '';

  return (
    <svg width='45' height='61' viewBox='0 0 45 61' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M23.1111 60.3726C22.9028 60.7212 22.4167 61 22 61C21.5139 61 21.0972 60.7212 20.8889 60.3726L4.56944 36.9062C2.90278 34.0481 2 30.6322 2 27.0769C2 15.9928 10.9583 7 22 7C33.0417 7 42 15.9928 42 27.0769C42 30.6322 41.0278 34.0481 39.4306 36.9062L23.1111 60.3726ZM14.5007 27.0756C14.5007 31.2583 17.834 34.6044 22.0007 34.6044C26.1674 34.6044 29.5007 31.2583 29.5007 27.0756C29.5007 22.8929 26.1674 19.5467 22.0007 19.5467C17.834 19.5467 14.5007 22.8929 14.5007 27.0756Z'
        fill={selected ? 'white' : '#B30200'}
        stroke={selected ? '#B30200' : ''}
        stroke-width={selected ? '2' : ''}
      />
      <circle cx='22' cy='27' r='14' fill={selected ? '#B30200' : 'white'} />
      {context == 'place'
        ? innerIconPlace
        : context == 'address'
          ? innerIconAddress
          : context == 'trafficcomp'
            ? innerIconTraffic
            : context == 'postal_code'
              ? innerIconPostalCode
              : context == 'canton'
                ? innerIconCanton
                : context == 'id'
                  ? innerIconId
                  : innerIconDefault}
    </svg>
  );
};

export class Marker extends React.Component {
  componentDidMount() {
    this.markerPromise = wrappedPromise();
    this.renderMarker();
  }

  componentDidUpdate(prevProps) {
    const { position, map, icon, colorCustomMarker, circle } = this.props;
    const positionsUnchanged = JSON.stringify(position) === JSON.stringify(prevProps.position);

    if (
      (!positionsUnchanged && (map !== prevProps.map || position !== prevProps.position || icon !== prevProps.icon)) ||
      (positionsUnchanged && colorCustomMarker !== prevProps.colorCustomMarker) ||
      (circle && circle !== prevProps.circle)
    ) {
      if (this.marker) {
        this.marker.setMap(null);
      }
      this.renderMarker();
    } else if (map !== prevProps.map) {
      // first mount
      this.renderMarker();
    }
  }

  componentWillUnmount() {
    if (this.marker) {
      this.marker.setMap(null);
    }
  }

  renderMarker() {
    const {
      map,
      google,
      position,
      mapCenter,
      colorCustomMarker,
      selected,
      productType,
      useCustomMarker,
      useIconsByContext,
      context,
      icon,
      label,
      draggable,
      idx,
      title,
      circle,
      ...props
    } = this.props;

    if (!google) {
      return null;
    }

    let pos = position || mapCenter;

    if (!(pos instanceof google.maps.LatLng)) {
      pos = new google.maps.LatLng(pos.lat, pos.lng);
    }

    let _icon;

    if (useCustomMarker) {
      if (useIconsByContext) {
        _icon = encodeSvg(getIconByContext(context, selected));
      } else {
        _icon = encodeSvg(getIconMarker(colorCustomMarker, productType));
      }
    } else {
      const _icon = icon;
    }

    const pref = {
      map,
      position: pos,
      icon: _icon,
      label,
      title,
      zIndex: colorCustomMarker === '#B30200' ? 1000 + idx : idx + 10,
      // that should prevent blinking
      // optimized: false,
      draggable,
      ...props,
    };
    this.marker = new google.maps.Marker(pref);

    if (circle) {
      this.marker.bindTo('position', circle, 'center');
    }

    evtNames.forEach((e) => {
      this.marker.addListener(e, this.handleEvent(e));
    });

    this.markerPromise.resolve(this.marker);
  }

  getMarker() {
    return this.markerPromise;
  }

  handleEvent(evt) {
    return (e) => {
      const evtName = `on${camelize(evt)}`;
      if (this.props[evtName]) {
        this.props[evtName](this.props, this.marker, e);
      }
    };
  }

  render() {
    return null;
  }
}

Marker.propTypes2 = {
  position: propTypes2.object,
  map: propTypes2.object,
  idx: propTypes2.number,
  colorCustomMarker: propTypes2.string,
  useCustomMarker: propTypes2.bool,
  draggable: propTypes2.bool,
};

Marker.defaultProps = {
  name: 'Marker',
  colorCustomMarker: '#B30200',
  selected: false,
};
